<template>
    <div v-if="normalizedErrorItems.length > 0">
        <CheckErrorContainer
            v-for="(v, k) in normalizedErrorItems"
            :key="v.error"
            :class="{ 'border-b-0': k === normalizedErrorItems.length - 1 }"
            :indentation-level
        >
            <ul class="list-none bg-transparent text-base text-ds-primary-500 marker:text-ds-primary-600">
                <li>
                    <div>{{ v.error }}</div>
                    <div
                        v-if="v.recommendation"
                        style="margin-bottom: 0"
                    >
                        <div class="inline-block text-ds-orange-600">Recommendation:</div>
                        {{ v.recommendation }}
                    </div>
                </li>
            </ul>
        </CheckErrorContainer>
    </div>
</template>

<script lang="ts" setup>
import type { CheckErrorRecommendation, CheckResult } from '@/api/interfaces/identity-verification-report.api';
import { notifyWarning } from '@/bugsnag';
import { computed } from 'vue';
import CheckErrorContainer from './CheckErrorContainer.vue';

const props = withDefaults(defineProps<{ value: CheckResult; indentationLevel?: number }>(), { indentationLevel: 2 });

const normalizedErrorItems = computed(() => {
    const infoList = props.value.infoList ?? undefined;
    // if infoList is a bare object, convert it to an array
    const castInfoList = infoList as CheckErrorRecommendation;
    if (infoList && castInfoList.error && castInfoList.recommendation) {
        return [
            {
                error: castInfoList.error,
                recommendation: castInfoList.recommendation,
            },
        ];
    }
    if (!Array.isArray(infoList)) {
        notifyWarning('Unexpected infoList value', 'CheckErrorList:normalizedErrorItems', {
            errorValues: props.value,
        });
        return [];
    }
    return infoList.map(item => {
        if (typeof item === 'string') {
            return { error: item };
        }
        return { error: item.error, recommendation: item.recommendation };
    });
});
</script>
